import React from 'react';
import Box, { TBoxProps } from '../../components/Box/Box';
import withStyleProps from '../../utils/styleProps/withStyleProps';
import stripStyleProps from '../../utils/styleProps/stripStyleProps';
import { TStyleProps } from '../../types/TStyleProps';

type TUtilsBlockProps = {
  as?: TBoxProps['as'];
} & TStyleProps &
  React.HTMLAttributes<any>;

const UtilsBlock = ({ as = 'div', ...props }: TUtilsBlockProps) => {
  const utilities = withStyleProps(props);
  const cleanProps = stripStyleProps(props);
  return <Box as={as} name="UtilsBlock" utilities={utilities} {...cleanProps} />;
};

export default UtilsBlock;
